import { useCallback } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { getOpenedTaskId } from '../../../../../redux/general/selectors';
import { deleteTaskFileAction, getTaskAction } from '../../../../../redux/tasks/actions';
import {
  getOpenedTaskParticipants,
  getOpenedTaskRoom,
  getOpenedTaskTitle,
} from '../../../../../redux/tasks/taskEntities/selectors';

import TaskChatArea from '../../global/TaskChatArea';

const TaskDetailsCommentsInput = ({
  taskId,
  taskParticipants,
  taskRoom,
  taskTitle,
}) => {
  const dispatch = useDispatch();
  const params = useParams();

  const delAttachment = useCallback(
    async (fileId) => {
      await dispatch(
        deleteTaskFileAction(taskId || params.taskid, fileId, () => dispatch(getTaskAction(taskId || params.taskid))),
      );
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [params.taskid, taskId],
  );

  return (
    <TaskChatArea
      roomId={taskRoom}
      members={taskParticipants}
      taskId={taskId}
      taskTitle={taskTitle}
      delAttachment={delAttachment}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    taskId: getOpenedTaskId(state),
    taskParticipants: getOpenedTaskParticipants(state),
    taskRoom: getOpenedTaskRoom(state),
    taskTitle: getOpenedTaskTitle(state),
  };
};

export default connect(mapStateToProps)(TaskDetailsCommentsInput);
